import React from 'react'

import {
  RuleBuilderErrorIcon,
  TestCopy,
  dummyTextBlocks,
  RuleItemRightExpandedCopy,
  TestDismiss
} from '../../../src/components/RuleBuilder/stories/RuleBuilder.story-helpers'

import {RuleBuilderIcon} from '@fuegokit/react/components/RuleBuilder'

const RocketShipIcon = () => {
  return <RuleBuilderIcon iconId="project" />
}

const CheckMarkIcon = () => {
  return <RuleBuilderIcon iconId="issue" />
}

export {
  RocketShipIcon,
  RuleBuilderErrorIcon as ErrorIcon,
  CheckMarkIcon,
  TestCopy,
  dummyTextBlocks,
  RuleItemRightExpandedCopy,
  TestDismiss as DismissButton
}
